import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appPhoneNumberMask]'
})
export class PhoneNumberMaskDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInput(event: any) {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, '');

    // Add plus sign if not already present
    if (!value.startsWith('+')) {
      value = '+' + value;
    }

    // Apply mask
    let maskedValue = '+';
    for (let i = 1; i < value.length && i <= 11; i++) {
      if (i === 2) {
        maskedValue += ' (';
      } else if (i === 5) {
        maskedValue += ') ';
      } else if (i === 8) {
        maskedValue += '-';
      }
      maskedValue += value.charAt(i);
    }

    console.log("MASSSSKEEDDDD VALUEEE : " + maskedValue)

    input.value = maskedValue;
  }
}



// WEBPACK FOOTER //
// ./src/providers/phoneMask.directive.ts